import React from 'react'
import { CircularProgress } from '@material-ui/core'
import './Spinner.scss'

const Spinner = () => {
  return <CircularProgress className="spinner" />
}

export default Spinner
